import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
// import Business from '../views/Business.vue'
// import Home from '../views/Home.vue'
// import index2 from '../views/index2.vue'
// import fireControl from '../views/fireControl.vue'
// import Activity from '../views/Activity.vue'
// import Security from '../views/Security.vue'
// import transaction from '../views/transaction.vue'
// import enerjy from '../views/enerjy'
// import car from '../views/car'
// import environment from '../views/environment'
// import construct from '../views/construct'
Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'Index',
	  component: Index
	},
  // {
  //   path: '/business',
  //   name: '商家数据',
  //   component: Business
  // },
  // {
  //   path: '/home',
  //   name: '价格数据',
  //   component: Home
  // },
  // {
  //   path: '/index2',
  //   name: '分平台首页',
  //   component: index2
  // },
  // {
  //   path: '/Security',
  //   name: '安防系统',
  //   component: Security
  // },
  // {
  //   path: '/Activity',
  //   name: '活跃度',
  //   component: Activity
  // },
  // {
  //   path: '/fireControl',
  //   name: '消防管理',
  //   component: fireControl
  // },
  // {
  //   path: '/transaction',
  //   name: '交易数据',
  //   component: transaction
  // },
  // {
  //   path: '/enerjy',
  //   name: '能耗监测',
  //   component: enerjy
  // },
  // {
  //   path: '/car',
  //   name: '车辆管理',
  //   component: car
  // },
  // {
  //   path: '/environment',
  //   name: '环境监测',
  //   component: environment
  // }
  // ,
  // {
  //   path: '/construct',
  //   name: '环境监测',
  //   component: construct
  // }
]

const router = new VueRouter({
  routes
})

export default router
